import React, { Component } from "react";
import Select from "react-select";
import Switch from "@material-ui/core/Switch";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class VisitaGrupo2 extends Component {
  render() {
    return (
      <>
        <fieldset className="panel">
          <legend>Datos generales</legend>

          <div className="container">
            <div className="row">
              {this.props.state.establecimiento_registrado ? (
                <div className="col-lg-11">
                  <div className="form-group">
                    <label htmlFor="razon_social">
                      Razón social del establecimiento:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    {/* <Select
                    id="razon_social"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    onChange={(e) =>
                      this.props.component.handleRazonSocialChange(e)
                    }
                    theme="neutral40"
                    options={this.props.state.establecimientos}
                    getOptionLabel={(establecimiento) =>
                      establecimiento.razon_social
                    }
                    getOptionValue={(establecimiento) => establecimiento.id}
                  /> */}
                    <select
                      name="razon_social"
                      id="razon_social"
                      onChange={(e) =>
                        this.props.component.handleRazonSocialChange(e)
                      }
                      value={this.props.state.establecimiento_id}
                      className="form-control"
                    >
                      <option value="" disabled>
                        Seleccione
                      </option>
                      {this.props.state.establecimientos.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.razon_social.toUpperCase()}
                        </option>
                      ))}
                    </select>
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="razon_social-error"
                    ></div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="razon_social">
                        Razón social del establecimiento:{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        value={
                          this.props.state.razon_social != null
                            ? this.props.state.razon_social
                            : ""
                        }
                        name="razon_social"
                        onChange={(e) =>
                          this.props.component.handleRazonSocialTextoChange(e)
                        }
                        className="form-control"
                        id="razon_social"
                        placeholder="Razón social"
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="razon_social-error"
                      ></div>
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="form-group">
                      <label htmlFor="tipo_establecimiento">
                        Tipo de establecimiento:{" "}
                        <span className="text-danger"> *</span>
                      </label>

                      <select
                        name="tipo_establecimiento"
                        id="tipo_establecimiento"
                        onChange={(e) =>
                          this.props.component.handleTipoEstablecimientoChange(
                            e
                          )
                        }
                        value={
                          this.props.state.tipo_establecimiento != null
                            ? this.props.state.tipo_establecimiento
                            : ""
                        }
                        className="form-control"
                      >
                        <option value="" disabled>
                          Seleccione
                        </option>
                        {this.props.state.cat_tipo_establecimiento.map(
                          (option) => (
                            <option key={option.id} value={option.id}>
                              {option.descripcion.toUpperCase()}
                            </option>
                          )
                        )}
                      </select>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="tipo_establecimiento-error"
                      ></div>
                    </div>
                  </div>
                </>
              )}
              <div className="col-lg-1">
                <div className="form-group">
                  <label htmlFor="establecimiento_registrado">
                    Registrado:
                  </label>
                  <br />
                  <Switch
                    className="establecimiento_registrado"
                    checked={this.props.state.establecimiento_registrado}
                    name="establecimiento_registrado"
                    onChange={(e) =>
                      this.props.component.handleEstablecimientoRegistradoChange(
                        e
                      )
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="actividad">
                    Actividad: <span className="text-danger"> *</span>
                  </label>

                  <select
                    name="actividad_id"
                    id="actividad_id"
                    onChange={(e) =>
                      this.props.component.handleActividadChange(e)
                    }
                    value={this.props.state.actividad_id}
                    className="form-control"
                  >
                    <option value="" disabled>
                      Seleccione
                    </option>
                    {this.props.state.cat_actividades.map((option) => (
                      <option
                        key={option.id}
                        value={option.id}
                        data-folio-licencia={option.folio_licencia}
                      >
                        {option.descripcion.toUpperCase()}
                      </option>
                    ))}
                  </select>
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="actividad_id-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="licencia_establecimiento">
                    Licencia de establecimiento:{" "}
                    <span className="text-danger campo-obligatorio"> *</span>
                  </label>
                  <input
                    type="text"
                    value={
                      this.props.state.licencia_establecimiento != null
                        ? this.props.state.licencia_establecimiento
                        : ""
                    }
                    onChange={(e) =>
                      this.props.component.handleLicenciaEstablecimientoChange(
                        e
                      )
                    }
                    name="licencia_establecimiento"
                    readOnly
                    className="form-control"
                    id="licencia_establecimiento"
                    placeholder="Licencia de establecimiento"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="licencia_establecimiento-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="folio_manual">Folio manual: </label>
                  <input
                    type="text"
                    value={
                      this.props.state.folio_manual != null
                        ? this.props.state.folio_manual
                        : ""
                    }
                    onChange={(e) =>
                      this.props.component.handleFolioManualChange(e)
                    }
                    name="folio_manual"
                    className="form-control"
                    id="folio_manual"
                    placeholder="Folio manual"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="direccion">
                    Dirección: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    value={this.props.state.direccion}
                    readOnly
                    onChange={(e) =>
                      this.props.component.handleDireccionChange(e)
                    }
                    name="direccion"
                    className="form-control"
                    id="direccion"
                    placeholder="Dirección del establecimiento"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="direccion-error"
                  ></div>
                </div>
              </div>
              {this.props.state.establecimiento_registrado ? (
                this.props.state.nombreMunicipio !== null &&
                this.props.state.nombreDepartamento !== null ? (
                  <>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="departamento_id">
                          Departamento: <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="text"
                          name="departamento_id"
                          readOnly
                          value={
                            this.props.state.nombreDepartamento != null
                              ? this.props.state.nombreDepartamento.toUpperCase()
                              : ""
                          }
                          className="form-control"
                          id="departamento_id"
                          placeholder="Departamento"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="departamento_id-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="municipio_id">
                          Municipio: <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="text"
                          name="municipio_id"
                          readOnly
                          value={
                            this.props.state.nombreMunicipio != null
                              ? this.props.state.nombreMunicipio.toUpperCase()
                              : ""
                          }
                          className="form-control"
                          id="municipio_id"
                          placeholder="Municipio_id"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="municipio_id-error"
                        ></div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="pais">
                        País: <span className="text-danger"> *</span>
                      </label>

                      <input
                        type="text"
                        name="nombrePais"
                        readOnly
                        value={
                          this.props.state.nombrePais != null
                            ? this.props.state.nombrePais
                            : ""
                        }
                        className="form-control"
                        id="nombrePais"
                        placeholder="País"
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="nombrePais-error"
                      ></div>
                    </div>
                  </div>
                )
              ) : this.props.state.tipo_establecimiento === "1" ||
                this.props.state.tipo_establecimiento === "3" ? (
                <>
                  <div className="col-lg-3">
                    <div className="form-group">
                      <label htmlFor="departamento">
                        Departamento: <span className="text-danger"> *</span>
                      </label>

                      <select
                        name="departamento_id"
                        id="departamento_id"
                        onChange={(e) =>
                          this.props.component.handleDepartamentoChange(e)
                        }
                        value={
                          this.props.state.departamento_id != null
                            ? this.props.state.departamento_id
                            : ""
                        }
                        className="form-control"
                        placeholder="Seleccione"
                      >
                        <option value="" disabled>
                          Seleccione
                        </option>
                        {this.props.state.locations.departamentos.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.name.toUpperCase()}
                          </option>
                        ))}
                      </select>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="departamento_id-error"
                      ></div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="form-group">
                      <label htmlFor="municipio">
                        Municipio: <span className="text-danger"> *</span>
                      </label>

                      <select
                        name="municipio_id"
                        id="municipio_id"
                        onChange={(e) =>
                          this.props.component.handleMunicipioChange(e)
                        }
                        value={
                          this.props.state.municipio_id != null
                            ? this.props.state.municipio_id
                            : ""
                        }
                        className="form-control"
                        placeholder="Seleccione"
                      >
                        <option value="" disabled>
                          Seleccione
                        </option>
                        {this.props.state.municipios.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.name.toUpperCase()}
                          </option>
                        ))}
                      </select>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="municipio_id-error"
                      ></div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="nombrePais">
                      País: <span className="text-danger"> *</span>
                    </label>

                    <select
                      name="nombrePais"
                      id="nombrePais"
                      onChange={(e) => this.props.component.handlePaisChange(e)}
                      value={this.props.state.pais_id}
                      className="form-control"
                    >
                      <option value="" disabled>
                        Seleccione
                      </option>
                      {this.props.state.cat_paises.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                    </select>

                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="nombrePais-error"
                    ></div>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="latitud">
                    Latitud: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    value={
                      this.props.state.latitud != null
                        ? this.props.state.latitud
                        : ""
                    }
                    onChange={(e) =>
                      this.props.component.handleLatitudChange(e)
                    }
                    name="latitud"
                    readOnly
                    className="form-control"
                    id="latitud"
                    placeholder="Latitud"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="latitud-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="longitud">
                    Longitud: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    value={
                      this.props.state.longitud != null
                        ? this.props.state.longitud
                        : ""
                    }
                    onChange={(e) =>
                      this.props.component.handleLongitudChange(e)
                    }
                    name="longitud"
                    readOnly
                    className="form-control"
                    id="longitud"
                    placeholder="Longitud"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="longitud-error"
                  ></div>
                </div>
              </div>
              <div
                className={
                  this.props.state.tipo_encuesta === "3"
                    ? "col-lg-3"
                    : "col-lg-6"
                }
              >
                <div className="form-group">
                  <label htmlFor="folio_establecimiento">
                    Código del establecimiento:{" "}
                    <span className="text-danger campo-obligatorio"> *</span>
                  </label>
                  <input
                    type="text"
                    onChange={(e) =>
                      this.props.component.handleFolioEstablecimientoChange(e)
                    }
                    name="folio_establecimiento"
                    value={
                      this.props.state.folio_establecimiento != null
                        ? this.props.state.folio_establecimiento
                        : ""
                    }
                    className="form-control"
                    readOnly
                    id="folio_establecimiento"
                    placeholder="Código del establecimiento"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="folio_establecimiento-error"
                  ></div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="telefono">
                    Teléfono: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="number"
                    step="1"
                    min="0"
                    value={
                      this.props.state.telefono != null
                        ? this.props.state.telefono
                        : ""
                    }
                    name="telefono"
                    pattern={
                      this.props.state.tipo_establecimiento === "1" ||
                      this.props.state.tipo_establecimiento === "3"
                        ? "[0-9]{4}[0-9]{4}"
                        : "[0-9]+"
                    }
                    maxLength={
                      this.props.state.tipo_establecimiento === "1" ||
                      this.props.state.tipo_establecimiento === "3"
                        ? "8"
                        : "30"
                    }
                    onInput={(e) => this.props.component.maxLengthCheck(e)}
                    onChange={(e) =>
                      this.props.component.handleTelefonoChange(e)
                    }
                    className="form-control"
                    id="telefono"
                    placeholder="Teléfono"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="telefono-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="correo_electronico">
                    Correo electrónico: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="email"
                    name="correo_electronico"
                    value={
                      this.props.state.correo_electronico != null
                        ? this.props.state.correo_electronico
                        : ""
                    }
                    onChange={(e) =>
                      this.props.component.handleCorreoElectronicoChange(e)
                    }
                    className="form-control"
                    id="correo_electronico"
                    placeholder="Correo electrónico"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="correo_electronico-error"
                  ></div>
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <div
                    id="listaRepresentantes"
                    className={
                      this.props.state.representantes_legales.length > 0
                        ? ""
                        : "hide"
                    }
                  >
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Representantes legales</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.state.representantes_legales.map((item) => (
                          <tr key={item.id}>
                            <td>{`${item.nombres} ${item.apellido_paterno} ${item.apellido_materno}`}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <div
                    id="listaRegentes"
                    className={
                      this.props.state.regentes.length > 0 ? "" : "hide"
                    }
                  >
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Regentes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.state.regentes.map((item) => (
                          <tr key={item.id}>
                            <td>{`${item.nombres} ${item.apellido_paterno} ${item.apellido_materno}`}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="panel">
          <legend>Inspectores</legend>

          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="inspectores">
                    Inspector(es): <span className="text-danger"> *</span>
                  </label>
                  <Select
                    isMulti
                    id="inspectores"
                    name="inspectores"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    onChange={(e) =>
                      this.props.component.handleInspectoresChange(e)
                    }
                    theme="neutral40"
                    value={
                      this.props.state.inspectores !== null ||
                      this.props.state.inspectores !== ""
                        ? this.props.state.inspectores
                        : { label: "Seleccione", key: "0" }
                    }
                    options={this.props.state.cat_inspectores}
                    getOptionLabel={(inspector) =>
                      inspector.inspector_nombre.toUpperCase()
                    }
                    getOptionValue={(inspector) => inspector.id}
                    noOptionsMessage={() => "No se encontraron más inspectores"}
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="inspectores-error"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        {this.props.state.tipo_encuesta === "4" ||
        this.props.state.tipo_encuesta === "5" ||
        this.props.state.tipo_encuesta === "7" ? (
          <fieldset className="panel">
            <legend>Lista de productos</legend>

            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="producto">
                      Nombre comercial: <span className="text-danger"> *</span>
                    </label>
                    {!this.props.state.reg_producto_manual ? (
                      <Select
                        id="productos_detalle_acta"
                        name="productos_detalle_acta"
                        isMulti={false}
                        isClearable={false}
                        styles={colourStyles}
                        placeholder="Seleccione"
                        onChange={(e) =>
                          this.props.component.handleProductoActaChange(
                            e,
                            "productos_detalle_acta"
                          )
                        }
                        value={
                          this.props.state.producto !== null ||
                          this.props.state.producto !== ""
                            ? this.props.state.producto
                            : { label: "Seleccione", key: "0" }
                        }
                        theme="neutral40"
                        options={this.props.state.cat_productos}
                        getOptionLabel={(producto) => producto.producto_nombre}
                        getOptionValue={(producto) => producto.id}
                        noOptionsMessage={() =>
                          "No se encontraron más productos"
                        }
                      />
                    ) : (
                      <input
                        type="text"
                        onChange={(e) =>
                          this.props.component.handleProductoActaChange(
                            e,
                            "productos_detalle_acta"
                          )
                        }
                        min="0"
                        value={this.props.state.producto}
                        step="1"
                        name="productos_detalle_acta"
                        id="productos_detalle_acta"
                        className="form-control"
                        placeholder="Nombre comercial"
                      />
                    )}
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="productos_detalle_acta-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="presentacionProducto">
                      Presentación: <span className="text-danger"> *</span>
                    </label>
                    {!this.props.state.reg_producto_manual ? (
                      <Select
                        id="presentacionProducto"
                        name="presentacionProducto"
                        isMulti={false}
                        isClearable={false}
                        styles={colourStyles}
                        placeholder="Seleccione"
                        onChange={(e) =>
                          this.props.component.handleProductoActaChange(
                            e,
                            "presentacionProducto"
                          )
                        }
                        value={
                          this.props.state.presentacion_producto !== null ||
                          this.props.state.presentacion_producto !== ""
                            ? this.props.state.presentacion_producto
                            : { label: "Seleccione", key: "0" }
                        }
                        theme="neutral40"
                        options={this.props.state.cat_presentacion_producto}
                        getOptionLabel={(presentacion) => {
                          return !presentacion.empaque
                            ? `${presentacion.cantidad} ${presentacion.unidad_medida}`
                            : `${presentacion.empaque.toUpperCase()} (${
                                presentacion.cantidad
                              }${presentacion.unidad_medida})`;
                        }}
                        getOptionValue={(presentacion) => presentacion.id}
                        noOptionsMessage={() =>
                          "No se encontraron más presentaciones"
                        }
                      />
                    ) : (
                      <input
                        type="text"
                        onChange={(e) =>
                          this.props.component.handleProductoActaChange(
                            e,
                            "presentacionProducto"
                          )
                        }
                        value={this.props.state.presentacion_producto}
                        name="presentacionProducto"
                        id="presentacionProducto"
                        className="form-control"
                        placeholder="Presentación"
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="cantidadProducto">
                      Cantidad: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      onChange={(e) =>
                        this.props.component.handleProductoActaChange(
                          e,
                          "cantidadProducto"
                        )
                      }
                      value={this.props.state.cantidad_producto}
                      name="cantidadProducto"
                      className="form-control"
                      id="cantidadProducto"
                      placeholder="Cantidad"
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="motivo_acto">Motivo del acto:</label>{" "}
                    <span className="text-danger"> *</span>
                    <textarea
                      name="motivo_acto"
                      value={this.props.state.motivo_acto}
                      onChange={(e) =>
                        this.props.component.handleProductoActaChange(
                          e,
                          "motivo_acto"
                        )
                      }
                      id="motivo_acto"
                      className="form-control"
                      placeholder="Motivo del acto"
                      rows="1"
                    ></textarea>
                  </div>
                </div>
                {/* {this.props.state.establecimiento_registrado ? ( */}
                <div className="col-lg-1">
                  <div className="form-group">
                    <label htmlFor="reg_producto_manual">Manual:</label>
                    <br />
                    <Switch
                      className="reg_producto_manual"
                      checked={this.props.state.reg_producto_manual}
                      name="reg_producto_manual"
                      onChange={(e) =>
                        this.props.component.handleRegProductoManualChange(e)
                      }
                    />
                  </div>
                </div>
                {/* ) : null} */}
                <div className="col-lg-1" style={{ marginTop: "1.5em" }}>
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-info col-lg-12"
                      onClick={(e) =>
                        this.props.component.addProductoDetalle(e)
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>

              {/* Lista productos y su presentación */}

              <div
                className={
                  this.props.state.productos_detalle_acta.length > 0
                    ? "row"
                    : "row hide"
                }
              >
                <div id="listaProductos" className="col-lg-12">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th>Nombre comercial</th>
                        <th>Presentación</th>
                        <th>Cantidad</th>
                        <th>Motivo del acto</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.state.productos_detalle_acta.map(
                        (reg, index) => (
                          <tr key={index} id={"t" + index}>
                            <td>{reg.nombre_comercial}</td>
                            <td>{reg.presentacion}</td>
                            <td>{reg.cantidad}</td>
                            <td>{reg.motivo_acto}</td>
                            <td>
                              <button
                                type="button"
                                id={index}
                                onClick={(e) =>
                                  this.props.component.removeProductoDetalle(e)
                                }
                                className="btn btn-warning pull-right"
                              >
                                <i
                                  id={index}
                                  onClick={(e) =>
                                    this.props.component.removeProductoDetalle(
                                      e
                                    )
                                  }
                                  className="fas fa-trash"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </fieldset>
        ) : this.props.state.tipo_encuesta === "6" ? (
          <fieldset className="panel">
            <legend>Lista de actas de decomiso</legend>

            <div className="container">
              <div className="row mb-3">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="productos_detalle_acta">
                      Número de acta de decomiso:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.num_acta_decomiso}
                      onChange={(e) =>
                        this.props.component.handleProductoActaDestruccionChange(
                          e
                        )
                      }
                      name="productos_detalle_acta"
                      className="form-control"
                      id="productos_detalle_acta"
                      placeholder="Número de acta"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="productos_detalle_acta-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="form-group">
                    <label htmlFor="motivo_acto">Motivo del acto:</label>
                    <span className="text-danger"> *</span>
                    <textarea
                      name="motivo_acto"
                      value={this.props.state.motivo_acto}
                      onChange={(e) =>
                        this.props.component.handleProductoActaDestruccionChange(
                          e
                        )
                      }
                      id="motivo_acto"
                      className="form-control"
                      placeholder="Motivo del acto"
                      rows="1"
                    ></textarea>
                  </div>
                </div>

                <div className="col-lg-1" style={{ marginTop: "1.5em" }}>
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-info col-lg-12"
                      onClick={(e) =>
                        this.props.component.addProdActaDestruccion(e)
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>

              {/* Lista productos y su presentación */}

              <div
                className={
                  this.props.state.productos_detalle_acta.length > 0
                    ? "row"
                    : "row hide"
                }
              >
                {this.props.state.tipo_encuesta !== "6" ? (
                  <div id="listaProductos" className="col-lg-12">
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Nombre comercial</th>
                          <th>Presentación</th>
                          <th>Cantidad</th>
                          <th>Motivo del acto</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.state.productos_detalle_acta.map(
                          (reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.nombre_comercial}</td>
                              <td>{reg.presentacion}</td>
                              <td>{reg.cantidad}</td>
                              <td>{reg.motivo_acto}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={(e) =>
                                    this.props.component.removeProductoDetalle(
                                      e
                                    )
                                  }
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={(e) =>
                                      this.props.component.removeProductoDetalle(
                                        e
                                      )
                                    }
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div id="listaProductos" className="col-lg-12">
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Número de acta de decomiso</th>
                          <th>Motivo del acto</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.state.productos_detalle_acta.map(
                          (reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.num_acta_decomiso}</td>
                              <td>{reg.motivo_acto}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={(e) =>
                                    this.props.component.removeProductoDetalle(
                                      e
                                    )
                                  }
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={(e) =>
                                      this.props.component.removeProductoDetalle(
                                        e
                                      )
                                    }
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </fieldset>
        ) : null}
        {this.props.state.tipo_encuesta !== "7" ? (
          <fieldset className="panel">
            <legend>Dictamen de sanción</legend>
            <div className="container">
              <div className="form-group">
                <FormControlLabel
                  label="Sancionar establecimiento"
                  control={
                    <Checkbox
                      checked={this.props.state.establecimiento_sancionado}
                      onChange={(e) =>
                        this.props.component.handleSancionEstablecimientoCBChange(
                          e
                        )
                      }
                      style={{ color: "#fff" }}
                      name="checkedB"
                      color="primary"
                    />
                  }
                />
              </div>
            </div>
          </fieldset>
        ) : null}
        <hr />
        <button
          type="submit"
          onClick={(e) => this.props.component.handleSubmit(e)}
          className="btn btn-success btn-block"
        >
          Guardar
        </button>
      </>
    );
  }
}

export default VisitaGrupo2;
